module.exports = __webpack_public_path__ + "static/fipcpastelfloral4-16e4619dc6bd84ce19b2af4d7f7dfd50.jpeg";